import type { StreamLifecycleState } from '@shared/types';

const LIFECYCLE_LABELS: Record<StreamLifecycleState, string> = {
  offline: 'Offline',
  starting: 'Starting…',
  live: 'Live',
  stopping: 'Stopping…',
  error: 'Error',
};

export function getStreamLifecycleLabel(state: StreamLifecycleState): string {
  return LIFECYCLE_LABELS[state];
}

export function getConnectionStatusLabel(connected: boolean): string {
  return connected ? 'Connected' : 'Not Connected';
}
